import warning from './warning';

export default function deprecate(condition, info, ...args) {
    const format = 'Usage of %s has been deprecated and will be removed in the next major version.';
    const rest = args.map(() => ' %s').join('');
    return warning(condition, format + rest, info, ...args);
}
